import React, {
  useEffect,
  useContext,
  useCallback,
  useState,
  useMemo,
} from "react";
// import _ from "lodash";
import { LibraryContext } from "../../../context/LibraryContext";
import constants, { libTypeIds, RESULT_STATUS } from "../../../constants";
import { isGradiousAdmin } from "../../../util";
import { useParams, useSearchParams } from "react-router-dom";
import AlertContext from "../../../context/AlertContext";
import useAxiosPrivate from "../../../Hooks/useAxiosPrivate";
import Table from "../../CommonComponents/Table";
import Loading from "../../Notification-Loading/Loading/Loading";
import { useDebouncedValue } from "../../../Hooks/useDebounceValue";
import SharedScopeBadge from "../../CommonComponents/SharedScopeBadge";
import UniversityListHooks from "../../../Hooks/UniversityListHooks";
import SharedScopeTitle from "../../CommonComponents/SharedScopeTitle";
import SharedScopeEdit from "../../CommonComponents/SharedScopeEdit";
import Subjects from "./Subjects";

const Icon = ({ name = "easy" }) => {
  const icons = {
    easy: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="21"
        height="21"
        viewBox="0 0 21 21"
        fill="none"
      >
        <path
          d="M19.7093 9.46581V10.3293C19.7082 12.3532 19.0528 14.3225 17.841 15.9435C16.6292 17.5645 14.9258 18.7503 12.985 19.3242C11.0442 19.898 8.96982 19.8291 7.07135 19.1277C5.17288 18.4263 3.55199 17.13 2.45043 15.4322C1.34887 13.7343 0.825656 11.7259 0.958821 9.70637C1.09199 7.68686 1.8744 5.7645 3.18936 4.226C4.50433 2.68749 6.28139 1.61526 8.25552 1.16924C10.2297 0.723207 12.2951 0.927271 14.1438 1.75099M19.7093 2.81556L10.3239 12.2104L7.50827 9.39474"
          stroke="#12B76A"
          strokeWidth="1.87708"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    medium: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="19"
        height="21"
        viewBox="0 0 19 21"
        fill="none"
      >
        <path
          d="M6.89833 17.242L7.44685 18.4756C7.60992 18.8429 7.87603 19.1549 8.21292 19.3739C8.5498 19.5929 8.94299 19.7094 9.34479 19.7093C9.7466 19.7094 10.1398 19.5929 10.4767 19.3739C10.8136 19.1549 11.0797 18.8429 11.2427 18.4756L11.7913 17.242C11.9865 16.8042 12.315 16.4393 12.7298 16.1992C13.1472 15.9584 13.6302 15.8558 14.1095 15.9061L15.4516 16.049C15.8511 16.0913 16.2543 16.0167 16.6123 15.8344C16.9702 15.6521 17.2676 15.3698 17.4684 15.0218C17.6694 14.674 17.7652 14.2754 17.7441 13.8743C17.723 13.4732 17.5859 13.0868 17.3495 12.762L16.5549 11.6702C16.2719 11.2785 16.1207 10.8071 16.1231 10.3239C16.1231 9.84203 16.2757 9.37254 16.5591 8.98282L17.3537 7.89098C17.5901 7.56623 17.7271 7.17984 17.7482 6.77871C17.7693 6.37759 17.6736 5.97895 17.4726 5.63118C17.2718 5.28321 16.9744 5.00094 16.6164 4.81862C16.2584 4.6363 15.8553 4.56174 15.4557 4.604L14.1136 4.74687C13.6343 4.7972 13.1514 4.69463 12.734 4.45384C12.3183 4.21235 11.9898 3.84548 11.7954 3.4058L11.2427 2.17214C11.0797 1.80491 10.8136 1.49289 10.4767 1.27391C10.1398 1.05493 9.7466 0.938411 9.34479 0.938477C8.94299 0.938411 8.5498 1.05493 8.21292 1.27391C7.87603 1.49289 7.60992 1.80491 7.44685 2.17214L6.89833 3.4058C6.70398 3.84548 6.37544 4.21235 5.95979 4.45384C5.54234 4.69463 5.05942 4.7972 4.58013 4.74687L3.23384 4.604C2.83434 4.56174 2.43115 4.6363 2.07316 4.81862C1.71518 5.00094 1.41778 5.28321 1.21702 5.63118C1.01601 5.97895 0.920241 6.37759 0.941343 6.77871C0.962445 7.17984 1.09951 7.56623 1.33591 7.89098L2.13054 8.98282C2.41392 9.37254 2.56653 9.84203 2.56644 10.3239C2.56653 10.8058 2.41392 11.2752 2.13054 11.665L1.33591 12.7568C1.09951 13.0816 0.962445 13.4679 0.941343 13.8691C0.920241 14.2702 1.01601 14.6688 1.21702 15.0166C1.41798 15.3644 1.71542 15.6465 2.07335 15.8288C2.43128 16.0111 2.83437 16.0858 3.23384 16.0438L4.57596 15.9009C5.05524 15.8506 5.53817 15.9532 5.95562 16.1939C6.37282 16.4348 6.70289 16.8017 6.89833 17.242Z"
          stroke="#F79009"
          strokeWidth="1.87708"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.34312 13.1395C10.8981 13.1395 12.1587 11.8789 12.1587 10.3239C12.1587 8.76887 10.8981 7.50827 9.34312 7.50827C7.78809 7.50827 6.52749 8.76887 6.52749 10.3239C6.52749 11.8789 7.78809 13.1395 9.34312 13.1395Z"
          stroke="#F79009"
          strokeWidth="1.87708"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    hard: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="21"
        height="21"
        viewBox="0 0 21 21"
        fill="none"
      >
        <path
          d="M14.078 6.56973V3.7541L16.8936 0.938477L17.8322 2.81556L19.7093 3.7541L16.8936 6.56973H14.078ZM14.078 6.56973L10.3239 10.3238M19.7093 10.3239C19.7093 15.5073 15.5073 19.7093 10.3239 19.7093C5.14047 19.7093 0.938477 15.5073 0.938477 10.3239C0.938477 5.14047 5.14047 0.938477 10.3239 0.938477M15.0166 10.3239C15.0166 12.9156 12.9156 15.0166 10.3239 15.0166C7.73218 15.0166 5.63118 12.9156 5.63118 10.3239C5.63118 7.73218 7.73218 5.63118 10.3239 5.63118"
          stroke="#F04438"
          strokeWidth="1.87708"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    total: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M7.50827 0.938477V14.0781M0.938477 7.50827H14.0781"
          stroke="#2E90FA"
          strokeWidth="1.87708"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    info: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="15"
        height="15"
        viewBox="0 0 15 15"
        fill="none"
      >
        <path
          d="M7.46647 10.1333V7.46665M7.46647 4.79999H7.47314M14.1331 7.46665C14.1331 11.1486 11.1484 14.1333 7.46647 14.1333C3.78457 14.1333 0.799805 11.1486 0.799805 7.46665C0.799805 3.78476 3.78457 0.799988 7.46647 0.799988C11.1484 0.799988 14.1331 3.78476 14.1331 7.46665Z"
          stroke="#667085"
          stroke-width="1.6"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    ),
  };
  return icons[name] || icons.easy;
};

const StatsCard = ({ color = "#FFEFE3", name = "Easy", value = 0 }) => {
  return (
    <div className="topicStats" style={{ background: color }}>
      <div className="leftStats">
        <span className="leftStatsIcon">
          <Icon name={name?.toLowerCase()} />
        </span>
        <span className="leftStatsName">{name}</span>
      </div>
      <div className="rightStatsValue">{value}</div>
    </div>
  );
};

const columns = [
  { id: "topic", key: "topic", title: "Topic"},
  {
    id: "shareScope",
    key: "shareScope",
    title: <SharedScopeTitle />,

    className: "shareScope",
  },
  { id: "edit", key: "edit", title: "", className: "edit" },
  {
    id: "easy",
    key: "easy",
    title: "EASY",

    className: "topicComplexity",
  },
  {
    id: "medium",
    key: "medium",
    title: "MEDIUM",

    className: "topicComplexity",
  },
  {
    id: "hard",
    key: "hard",
    title: "HARD",

    className: "topicComplexity",
  },
  {
    id: "total",
    key: "total",
    title: "TOTAL",

    className: "topicComplexity",
  },
];

const SharedTopics = () => {
  const { setIsLoaded, setShowNotify, isLoaded } = useContext(AlertContext);
  const {
    setSharedTopics,
    setFilterSharedTopics,
    filterSharedTopics,
    searchText,
    selectedScope,
  } = useContext(LibraryContext);
  const { type } = useParams();
  const axios = useAxiosPrivate();
  const [searchParams, setSearchParams] = useSearchParams();
  const UniversityListHks = UniversityListHooks();
  const isMcq = useMemo(() => +type === libTypeIds.MCQ, [type]);
  const subId = searchParams.get("subId") || null;

  const [statsCount, setStatsCount] = useState(
    Object.keys(constants.complexityid).reduce(
      (acc, cur) => ({ ...acc, [cur.toLowerCase()]: 0 }),
      { total: 0 },
    ),
  );

  // console.log("statsCount", statsCount);

  // Function to transform API data
  const transformApiData = (apiData) => {
    let easy = 0,
      medium = 0,
      hard = 0,
      total = 0;
    const data = apiData.map((item) => {
      const easyComplexity = item.complexities.find(
        (c) =>
          c.name.toLowerCase() === "easy" ||
          c.id === constants.complexityid.EASY,
      );
      const mediumComplexity = item.complexities.find(
        (c) =>
          c.name.toLowerCase() === "medium" ||
          c.id === constants.complexityid.MEDIUM,
      );
      const hardComplexity = item.complexities.find(
        (c) =>
          c.name.toLowerCase() === "difficult" ||
          c.id === constants.complexityid.HARD,
      );

      const easyCount = easyComplexity?.count || 0;
      const mediumCount = mediumComplexity?.count || 0;
      const hardCount = hardComplexity?.count || 0;
      const totalCount = easyCount + mediumCount + hardCount;
      easy += easyCount;
      medium += mediumCount;
      hard += hardCount;
      total += totalCount;
      return {
        tid: item.tid,
        topic: item.tname,
        shareScope: item.share_scope,
        easy: easyCount,
        medium: mediumCount,
        hard: hardCount,
        total: totalCount,
        sharedCompanies: item.shared_companies || [],
      };
    });
    setStatsCount((prev) => ({ ...prev, easy, medium, total, hard }));
    return data;
  };
  const debouncedSearchText = useDebouncedValue(searchText, 1000);

  const fetchSharedTopics = useCallback(async () => {
    try {
      setIsLoaded(true);
      const response = await axios.get(
        `node/admin/library/${type}/shared?scope=${selectedScope}&searchText=${debouncedSearchText}${subId ? `&subId=${subId}`:""}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      if (response.data.resultCode) {
        let data = response.data.data
          ? typeof response.data.data === "string"
            ? JSON.parse(response.data.data)
            : response.data.data
          : [];

        // 1. Use .reduce() - it's the professional way to sum arrays
        // console.log("data:",data);
        
        // const totalEasyCount = data.reduce((accumulator, currentItem) => {
        //   const easyComplexity = currentItem.complexities?.find(c => c.id == 1);
        //   const count = easyComplexity ? easyComplexity.count : 0;

        //   return accumulator + count;
        // }, 0);
        // const totalMediumCount = data.reduce((accumulator, currentItem) => {
        //   const easyComplexity = currentItem.complexities?.find(c => c.id == 2);
        //   const count = easyComplexity ? easyComplexity.count : 0;

        //   return accumulator + count;
        // }, 0);
        // const totalHardCount = data.reduce((accumulator, currentItem) => {
        //   const easyComplexity = currentItem.complexities?.find(c => c.id == 3);
        //   const count = easyComplexity ? easyComplexity.count : 0;
        //   return accumulator + count;
        // }, 0);

        // console.log("Total Easy Count:", totalEasyCount, totalMediumCount,totalHardCount);


        // setSharedTopics(data);
        const transformedData = transformApiData(data);      
        setFilterSharedTopics(transformedData);
        setSharedTopics(transformedData);
        // console.log("dataaaaaaaaaaaaa", data);
      } else {
        setShowNotify({
          show: true,
          title: "Warning !",
          msg:
            response.data.msg ||
            "Something went wrong. Please try again later.",
        });
      }
    } catch (error) {
      if (error.message.includes("403")) {
        setShowNotify({
          show: true,
          title: "Warning !",
          msg: "You have been logged-out due to inactivity. Login again.",
          isUnAuth: true,
        });
      } else
        setShowNotify({
          show: true,
          title: "Error !",
          msg: "Something went wrong. Please try again later or contact gradious team.",
        });
    } finally {
      setIsLoaded(false);
    }
  }, [
    type,
    axios,
    setShowNotify,
    setIsLoaded,
    setSharedTopics,
    setFilterSharedTopics,
    debouncedSearchText,
    selectedScope,
  ]);

  useEffect(() => {
    fetchSharedTopics();
  }, [fetchSharedTopics]);

  const fetchUniversities = useCallback(
    () => UniversityListHks.fetchUniversities(),
    [],
  );

  useEffect(() => {
    fetchUniversities();
  }, [fetchUniversities]);

  const handleScopeUpdateInUI = (topicId, newScope, updatedCompanies) => {
    console.log("topcid", topicId, newScope, updatedCompanies);
    // Update the local state so the UI reflects the change immediately
    setFilterSharedTopics((prev) =>
      prev.map((item) =>
        item.tid === topicId
          ? { ...item, shareScope: newScope, sharedCompanies: updatedCompanies }
          : item,
      ),
    );
    setSharedTopics((prev) =>
      prev.map((item) =>
        item.tid === topicId
          ? { ...item, shareScope: newScope, sharedCompanies: updatedCompanies }
          : item,
      ),
    );
  };

  const GradiousAdmin = useMemo(() => isGradiousAdmin(), []);

  const headerCells = GradiousAdmin
    ? columns
    : columns.filter((col) => !["shareScope", "edit"].includes(col.key));

  // Custom row render function
  const renderCustomRow = (row, rowIndex, columns) => {
    return (
      <tr key={rowIndex} className="tableBodyRow">
        {columns.map((col, colIndex) => (
          <td
            key={colIndex}
            className={`tableData ${col.key} ${!["topic", "total"].includes(col.key)
              ? "topicComplexity"
              : col.key === "total"
                ? "topicTotal"
                : col.key === "shareScope"
                  ? "shareScope"
                  : ""
              }`}
          >
            {col.key === "shareScope" ? (
              <SharedScopeBadge
                shareScope={row.shareScope}
                sharedCompanies={row.sharedCompanies}
              />
            ) : col.key === "edit" ? (
              <div className="editIcon">
                <SharedScopeEdit
                  selectedRow={row}
                  onUpdateSuccess={handleScopeUpdateInUI}
                  from="topic"
                />
              </div>
            ) : (
              row[col.key]
            )}
          </td>
        ))}
      </tr>
    );
  };
  // if (isLoaded) return <Loading />;

  return (
    <div className="sharedTopicsContainer">
      {/* <div className="sharedTopicStats">
        <StatsCard name="Easy" value={statsCount.easy} color="#FFEFE3" />
        <StatsCard name="Medium" value={statsCount.medium} color="#FAEBD7" />
        <StatsCard name="Hard" value={statsCount.hard} color="#FFF4E6" />
        <StatsCard name="Total" value={statsCount.total} color="#E6EFFF" />
      </div> */}

      {isLoaded ? (
        <Loading />
      ) : (
        <React.Fragment>
          <Table
            columns={headerCells}
            data={filterSharedTopics}
            fixedHeader={true}
            //onRowClick={handleRowClick}
            renderRow={renderCustomRow}
            emptyText="No records found"
          />
        </React.Fragment>
      )}
    </div>
  );
};

export default SharedTopics;
